import React from "react";
import Heading from "src/components/Heading";
import RichText from "src/utils/RichText";
import Button from "src/components/Button";
import GetAny from "src/utils/GetAny";
import FluidImage from "src/utils/FluidImage";
import SbEditable from 'storyblok-react'

const FourByTwoGridOnBrandV1 = ({ blok }) => {
  return (
    <SbEditable content={blok} key={blok._uid}>
      <section className={`${blok.grey_bg ? "bg-midgrey lg:pt-16 py-16 sm:pt-20 sm:pb-24" : "bg-white lg:mt-16 my-16 sm:mt-20 sm:mb-24"}`}>
        <div className="lg:max-w-7xl max-w-4xl mx-auto">
          <div className="px-6">
            <span
              className="block font-insights-display text-lg lg:text-1xl uppercase"
              colour="darkgrey"
            >
              {blok.title ? blok.title : "Previous issues"}
            </span>
            <div className="grid lg:grid-cols-4 md:grid-cols-2 gap-8 pt-6 pb-12 relative">
              {GetAny(blok.items).map((item, index) => {
                return (
                  <div key={index}>
                    <div className="relative z-1">
                      <a
                        className="cursor-pointer relative hover:opacity-70 duration-300 block"
                        key={index}
                        href={`/${item.full_slug}`}
                      >
                        <FluidImage
                          className="mb-3 block"
                          image={item.content.thumbnail_image}
                        />
                      </a>
                    </div>
                    <Heading
                      size="h4"
                      className="font-insights-display text-xl lg:text-xl font-light mb-0 leading-none !leading-5"
                      colour="darkgrey"
                    >
                      {item.name}
                    </Heading>
                    <span className="font-insights-display text-xl lg:text-xl text-darkgrey font-semibold uppercase mb-2 block">
                      {item.content.season_release}
                    </span>
                    <p className="text-[0.8rem] text-darkgrey prose font-insights-body pb-14 row-span-3 font-light">
                      <RichText>{item.content.description}</RichText>
                    </p>
                    <Button
                      target={`/${item.full_slug}`}
                      className="bg-red group-hover:bg-darkred lg:absolute lg:bottom-0"
                    >
                      Download PDF
                    </Button>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </section>
    </SbEditable>
  );
};

export default FourByTwoGridOnBrandV1;
